import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=2a5bbd76&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VFlex,VLayout,VPagination})
